import {Component, ContentChild, EventEmitter, forwardRef, HostListener, Input, Output, TemplateRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

import { first } from 'rxjs';



@Component({
  selector: 'preferred-number-type',
  templateUrl: './preferred-number-type.component.html',
  styleUrls: ['./preferred-number-type.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PreferredNumberTypeComponent),
      multi: true
    }
  ]
})
export class PreferredNumberTypeComponent implements ControlValueAccessor {

  @ContentChild('validationTemplate') validationTemplate!: TemplateRef<any>;


  @Input()
  eveModel!: any;

  @Output() eveModelChange: EventEmitter<String> = new EventEmitter<String>();

  @Input()
  placeholder: string = "";


  onChange: any = () => { }
  onTouch: any = () => { }


  options: any[] = [
    { label: 'Group Number', value: 'DIVERSION_NUMBER' },
    { label: 'Calling Party', value: 'CALLING_PARTY' },
  ];

  filteredOptions!: string[];



  

  constructor() {
    
   }

  filterOptions($event: any) {
    let filtered : any[] = [];
    let query = $event.query;
   
    for(let i = 0; i < this.options.length; i++) {
      let option = this.options[i];
      if (option.label.toLowerCase().indexOf(query.toLowerCase()) != -1) {
        filtered.push(option);
      }
    }

    this.filteredOptions = [...filtered];

  }

  onClear(){
    this.onNgModelChange(null);
  }
  
  onNgModelChange(option: any) {
    this.eveModel = option;
    this.eveModelChange.emit(this.eveModel);

    this.onChange(this.eveModel);
    this.onTouch(this.eveModel);
  }

  registerOnChange(fn: any) {
    this.onChange = fn
  }
  registerOnTouched(fn: any) {
    this.onTouch = fn
  }

  writeValue(value: any): void {
    this.eveModel = value;
  }
}
